import { render } from "./DebugMenu.vue?vue&type=template&id=922756d6&scoped=true"
import script from "./DebugMenu.vue?vue&type=script&lang=js"
export * from "./DebugMenu.vue?vue&type=script&lang=js"

import "./DebugMenu.vue?vue&type=style&index=0&id=922756d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-922756d6"]])

export default __exports__